// extracted by mini-css-extract-plugin
module.exports = {"spinnerWrapper":"styles_spinnerWrapper__puH99","spinner":"styles_spinner__277mo","buttonWrapper":"styles_buttonWrapper__QrugU","hiddenLoadMore":"styles_hiddenLoadMore__Kqogo"};